import { render } from "./TheCollapse.vue?vue&type=template&id=76a7fcc4"
import script from "./TheCollapse.vue?vue&type=script&lang=js"
export * from "./TheCollapse.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__